$(document).ready(function(){
  $('.slider-banner')
    .on('init', function(slick) {
        $('.slider-banners-2').css('display','block');
        $('.slider-banners-3').css('display','block');
        $('.slider-banner').fadeIn(3000);
    })
    .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    fade: true,
    focusOnSelect: true,
    ccssEase: 'linear',
    arrows: true,
    autoplaySpeed: 4000,
    autoplay:false,
    vertical: false,
    infinite: true,
    lazyLoad: 'ondemand',
    responsive: [{
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
            autoplay:true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
          autoplay:false
        }
      }
    ]
  });
  $('.slider-menu').slick({
            slidesToShow: 8,
            mobileFirst: true,
            lazyLoad: 'ondemand',
            slidesToScroll: 1,
            fade: false,
            cssEase: 'linear',
            prevArrow: '<i class="arrow arrow-left fa fa-chevron-left" aria-hidden="true"></i>',
            nextArrow: '<i class="arrow arrow-right fa fa-chevron-right" aria-hidden="true"></i>',
            swipe: true,
            dots: false,
            arrows: true,
            vertical: false,
            infinite: true,
  });
});